/* eslint-disable no-unneeded-ternary */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LoginHeaderContainer } from './index.style';
import Typography from '../../atoms/Typography';
import Icon from '../../atoms/Icon';

import { colorsNameKey } from '../../const/theme.const';
import { getQueryVariable } from '../../utils/query';
import { createLoginUrl } from '../../utils/login';
import { TRANSLATION_KEYS } from '../../i18n/index.enum';

const LoginHeader = ({ logged: userLogged }) => {
  const { t } = useTranslation();
  const firstRender = useRef(true)

  useEffect(() => {
    const redirectToLogin = async () => {
      if (
        window.location.href.indexOf('localhost') < 0
        && !getQueryVariable('error')
        && !getQueryVariable('code')
        && !userLogged
      ) {
        const loginUrl = await createLoginUrl(false);
        // window.location.replace(loginUrl);
      }
    };

    redirectToLogin();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLogged]);

  const handleLoginClick = async () => {
    try {
      const loginUrl = await createLoginUrl();
      window.location.replace(loginUrl);
    } catch (error) {
      console.error('Errore durante la creazione dell\'URL di login:', error);
    }
  };

  return (
    <LoginHeaderContainer userLogged={userLogged}>
      {userLogged ? (
        <Icon
          size={24}
          color={colorsNameKey.WHITE}
          icon={Icon.ICONS_TYPE.USER}
        />
      ) : (
        <Typography
          onClick={handleLoginClick}
          tag="a"
          type={Typography.TYPES.HEADERLOGIN}
          color={colorsNameKey.WHITE}
        >
          {t(TRANSLATION_KEYS.HOMEPAGE.LOGIN)}
        </Typography>
      )}
    </LoginHeaderContainer>
  );
};

LoginHeader.defaultProps = {
  logged: null,
};

LoginHeader.propTypes = {
  logged: PropTypes.bool,
};

export default connect(
  ({ login: { logged } }) => ({ logged }),
)(LoginHeader);
